module.exports = __webpack_public_path__ + "static/media/createnew.c83ec67a.gif";